import { Button, Card, Input } from "antd";
import styled from "styled-components";

export const PatientCard = styled(Card)`
 border-color: transparent;
     box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
 /* width: 33%; */
 height:100%;
  border-radius: 15px;
  .ant-card-body {
    padding: 21px;
    padding-top: 0px;
}
  /* color:#FFFFFF; */
  .ant-card-head{
      border-bottom: none;
  }
  .ant-card-head-title{
      padding: 8px 0px;
      color: ${props => props.theme.colors.primary};
  }
  .ant-card-extra{
      padding: 8px 0px;

  }
`;

export const DetailSpan = styled.span`
    margin-left: 10px;
    text-transform: capitalize;
    font-size:14px;
`;
export const LabelSpan = styled.span`
    text-transform: capitalize;
    font-size:14px;
    font-weight: 500;
`;

export const InputBox = styled(Input)`
    input{
        font-size:14px;
    }
`;

export const XButton = styled(Button)`
    font-size:14px;
    border-radius:7px !important;
`;